import { render, staticRenderFns } from "./PrintReceipWithHolding.vue?vue&type=template&id=25f1ad9d&scoped=true"
import script from "./PrintReceipWithHolding.vue?vue&type=script&lang=js"
export * from "./PrintReceipWithHolding.vue?vue&type=script&lang=js"
import style0 from "./PrintReceipWithHolding.vue?vue&type=style&index=0&id=25f1ad9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f1ad9d",
  null
  
)

export default component.exports